import { Component, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { TemplateWorkflowListItem, TemplateWorkflowSearchRequest } from 'src/app/models';
import { Utilities, WorkflowContextService, WorkflowService } from 'src/app/services';
import { WorkflowTestAsClientComponent } from '../../workflow-test-as-client/workflow-test-as-client.component';

@Component({
  selector: 'wm-template-library-search',
  templateUrl: './template-library-search.component.html',
  styleUrl: './template-library-search.component.css',
  standalone: false
})
export class TemplateLibrarySearchComponent implements OnInit {
  name = '';
  tags = '';
  workflows: TemplateWorkflowListItem[] = [];
  useMockData = false;
  isLoading = false;
  rootURL: string;
  testWorkflowId: string;
  clientSub: Subscription;
  testVersionId: string;
  @ViewChild('testAsClientModal', { static: false }) testAsClientModal : WorkflowTestAsClientComponent;

  get startTestApplicationURL() {
    return `${this.rootURL}/home/StartWorkflowApplication?WorkflowId=${this.testWorkflowId}&isTestApplication=true`;
  }

  constructor(
    private _workflowSvc: WorkflowService,
    public _context: WorkflowContextService
  ) { }

  ngOnInit() {
    if (this._context.client) {
      this.init();
    } else {
      this.clientSub = this._context.client$.subscribe(() => {
        this.init();
      });
    }
  }

  ngOnDestroy() {
    if (this.clientSub) {
      this.clientSub.unsubscribe();
    }
  }

  init() {
    this.rootURL = Utilities.getRootURL();

    this.search();
  }

  testWorkflow() {
    window.open(this.startTestApplicationURL, '_blank');
  }

  search() {
    this.isLoading = true;

    const tagList = this.tags.split(',').map(t => t.trim()).filter(t => t);

    const request = new TemplateWorkflowSearchRequest({
      name: this.name,
      tags: tagList
    })

    this._workflowSvc.searchTemplateLibraryWorkflows(request, this.useMockData)
      .subscribe(response => {
        this.workflows = response.items;

        this.isLoading = false;
      });
  }

  setTestWorkflowId(workflowId: string, versionId: string) {
    this.testAsClientModal.reset();
    this.testWorkflowId = workflowId;
    this.testVersionId = versionId;
    this.testAsClientModal.open();
  }

  alertCannotOpenBuilder() {
    alert('A larger screen is required to view the full design of this workflow.');
  }
}
